import { render, staticRenderFns } from "./LoginSide.vue?vue&type=template&id=bc67e974"
import script from "./LoginSide.vue?vue&type=script&lang=js"
export * from "./LoginSide.vue?vue&type=script&lang=js"
import style0 from "./LoginSide.vue?vue&type=style&index=0&id=bc67e974&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc67e974')) {
      api.createRecord('bc67e974', component.options)
    } else {
      api.reload('bc67e974', component.options)
    }
    module.hot.accept("./LoginSide.vue?vue&type=template&id=bc67e974", function () {
      api.rerender('bc67e974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/LoginSide.vue"
export default component.exports